import "@hotwired/turbo-rails"
import "./controllers"

let isForwardNavigation = false
document.addEventListener("turbo:before-visit", () => { isForwardNavigation = true })
document.addEventListener("turbo:load", () => {
    if (isForwardNavigation) {
        isForwardNavigation = false
        window.scrollTo(0, 0)
    }
})

import "leaflet"

import * as Sentry from '@sentry/browser'
Sentry.init({
    dsn: process.env.SENTRY_URL,
    environment: process.env.RAILS_ENV
});
